export default {
    createSeventhStepSubmitRequest(formData) {
        return {
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            isPolicyAccepted: formData.isPolicyAccepted
        };
    }
};